import React from 'react'

export const ClientItem = ({ item }) => {
  if (item) {
    return <span>{item.name ? `${item.name}  ` : null}</span>
  } else {
    return null
  }
}
